import { writable } from 'svelte/store';

export const currentRoute = writable('/');
export const players = writable([]);